import { ButtonBase } from '@sparemin/blockhead';
import { fromJS } from 'immutable';
import React from 'react';

import { useTextOverlay } from '../../../../state/TextOverlayProvider';
import { block } from '../../utils';
import { OldStylePresetConfig } from './types';
import { getOldStyleOverlay } from './utils';

interface OldStylePresetProps {
  aspectRatio: number;
  preset: OldStylePresetConfig;
}

const OLD_PRESET_ICON_SRC =
  'https://static.sparemin.com/static/webapp-assets/text-preset/old-style-202504181101/preset@2x.png';

const OldStylePreset: React.FunctionComponent<OldStylePresetProps> = props => {
  const { aspectRatio } = props;

  const { onFullUpdate } = useTextOverlay();

  const handleClick = React.useCallback((): void => {
    const styleResetOverlay = getOldStyleOverlay(aspectRatio);

    onFullUpdate(currOverlay =>
      currOverlay.withMutations(s => {
        s.setIn(
          ['editor', 'textStyle'],
          fromJS({
            ...styleResetOverlay.getIn(['editor', 'textStyle'])?.toJS(),
            // We explicitly set `textOutline: undefined` here instead of inside style defaults
            // constants because undefined values are lost during the captions text overlay creation
            // and migration processes. Without this manual override, it's not possible to represent
            // a "disabled" text outline state correctly in the final overlay.
            textOutline: undefined,
          }),
        )
          .set(
            'advancedTextConfigs',
            fromJS(styleResetOverlay.get('advancedTextConfigs')),
          )
          .set(
            'advancedAnimation',
            fromJS(styleResetOverlay.get('advancedAnimation')),
          );
        return s;
      }),
    );
  }, [aspectRatio, onFullUpdate]);

  return (
    <ButtonBase className={block('preset-container')} onPress={handleClick}>
      <img
        className={block('preset-img')}
        src={OLD_PRESET_ICON_SRC}
        alt="old-preset"
      />
    </ButtonBase>
  );
};

export default OldStylePreset;
